const init = ({ el }) => {
  /* The original element that requested the module */
  const context = el;
  const placement = el.dataset.modulePlacement;

  /* CSS selectors to target */
  const cssSelectors = {
    formToggle: "[data-search-toggle]",
    formField: "[data-search-field]",
    formFieldValue: `q-${placement}`,
  };

  /* Context sensitive things to target */
  const selectors = {
    formToggle: context.querySelector(cssSelectors.formToggle),
    formField: context.querySelector(cssSelectors.formField),
    formFieldValue: document.getElementById(cssSelectors.formFieldValue),
  };

  selectors.formToggle.addEventListener("click", (event) => {
    const searchQuery = selectors.formFieldValue.value;

    if (searchQuery === "") {
      event.preventDefault();

      const isHidden =
        selectors.formField.getAttribute("aria-hidden") === "true";

      context.classList.toggle("has-focus");
      selectors.formField.setAttribute("aria-hidden", !isHidden);
      selectors.formToggle.blur();
      isHidden
        ? selectors.formFieldValue.focus()
        : selectors.formFieldValue.blur();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[data-module="search"]').forEach((el) => {
    init({ el });
  });
});
